// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import homePageEn from "../components/Homepage/locales/en.json";
import homePageDe from "../components/Homepage/locales/de.json";
import homePageFr from "../components/Homepage/locales/fr.json";
import homePagePt from "../components/Homepage/locales/pt.json";
import homePageEs from "../components/Homepage/locales/es.json";
import homePageIt from "../components/Homepage/locales/it.json";
import homePageRu from "../components/Homepage/locales/ru.json";
import homePageHi from "../components/Homepage/locales/hi.json";
import homePageJa from "../components/Homepage/locales/ja.json";
import homePageKo from "../components/Homepage/locales/ko.json";
import homePageTr from "../components/Homepage/locales/tr.json";
import homePagePl from "../components/Homepage/locales/pl.json";

import dashboardEn from "../components/Dashboard/Home/HomeContent/locales/en.json";
import dashboardDe from "../components/Dashboard/Home/HomeContent/locales/de.json";
import dashboardFr from "../components/Dashboard/Home/HomeContent/locales/fr.json";
import dashboardPt from "../components/Dashboard/Home/HomeContent/locales/pt.json";
import dashboardEs from "../components/Dashboard/Home/HomeContent/locales/es.json";
import dashboardIt from "../components/Dashboard/Home/HomeContent/locales/it.json";
import dashboardRu from "../components/Dashboard/Home/HomeContent/locales/ru.json";
import dashboardHi from "../components/Dashboard/Home/HomeContent/locales/hi.json";
import dashboardJa from "../components/Dashboard/Home/HomeContent/locales/ja.json";
import dashboardKo from "../components/Dashboard/Home/HomeContent/locales/ko.json";
import dashboardTr from "../components/Dashboard/Home/HomeContent/locales/tr.json";
import dashboardPl from "../components/Dashboard/Home/HomeContent/locales/pl.json";

import settingsEn from "../components/Dashboard/Settings/locales/en.json";
import settingsDe from "../components/Dashboard/Settings/locales/de.json";
import settingsFr from "../components/Dashboard/Settings/locales/fr.json";
import settingsPt from "../components/Dashboard/Settings/locales/pt.json";
import settingsEs from "../components/Dashboard/Settings/locales/es.json";
import settingsIt from "../components/Dashboard/Settings/locales/it.json";
import settingsRu from "../components/Dashboard/Settings/locales/ru.json";
import settingsHi from "../components/Dashboard/Settings/locales/hi.json";
import settingsJa from "../components/Dashboard/Settings/locales/ja.json";
import settingsKo from "../components/Dashboard/Settings/locales/ko.json";
import settingsTr from "../components/Dashboard/Settings/locales/tr.json";
import settingsPl from "../components/Dashboard/Settings/locales/pl.json";

import testMemeContainerEn from "../components/common/TestMemeContainer/locales/en.json";
import testMemeContainerDe from "../components/common/TestMemeContainer/locales/de.json";
import testMemeContainerFr from "../components/common/TestMemeContainer/locales/fr.json";
import testMemeContainerPt from "../components/common/TestMemeContainer/locales/pt.json";
import testMemeContainerEs from "../components/common/TestMemeContainer/locales/es.json";
import testMemeContainerIt from "../components/common/TestMemeContainer/locales/it.json";
import testMemeContainerRu from "../components/common/TestMemeContainer/locales/ru.json";
import testMemeContainerHi from "../components/common/TestMemeContainer/locales/hi.json";
import testMemeContainerJa from "../components/common/TestMemeContainer/locales/ja.json";
import testMemeContainerKo from "../components/common/TestMemeContainer/locales/ko.json";
import testMemeContainerTr from "../components/common/TestMemeContainer/locales/tr.json";
import testMemeContainerPl from "../components/common/TestMemeContainer/locales/pl.json";

import manualApprovalEn from "../components/Applications/memeApproval/locales/en.json";
import manualApprovalDe from "../components/Applications/memeApproval/locales/de.json";
import manualApprovalFr from "../components/Applications/memeApproval/locales/fr.json";
import manualApprovalPt from "../components/Applications/memeApproval/locales/pt.json";
import manualApprovalEs from "../components/Applications/memeApproval/locales/es.json";
import manualApprovalIt from "../components/Applications/memeApproval/locales/it.json";
import manualApprovalRu from "../components/Applications/memeApproval/locales/ru.json";
import manualApprovalHi from "../components/Applications/memeApproval/locales/hi.json";
import manualApprovalJa from "../components/Applications/memeApproval/locales/ja.json";
import manualApprovalKo from "../components/Applications/memeApproval/locales/ko.json";
import manualApprovalTr from "../components/Applications/memeApproval/locales/tr.json";
import manualApprovalPl from "../components/Applications/memeApproval/locales/pl.json";

import moderatorPageEn from "../components/Dashboard/Moderation/ModeratorList/locales/en.json";
import moderatorPageDe from "../components/Dashboard/Moderation/ModeratorList/locales/de.json";
import moderatorPageFr from "../components/Dashboard/Moderation/ModeratorList/locales/fr.json";
import moderatorPagePt from "../components/Dashboard/Moderation/ModeratorList/locales/pt.json";
import moderatorPageEs from "../components/Dashboard/Moderation/ModeratorList/locales/es.json";
import moderatorPageIt from "../components/Dashboard/Moderation/ModeratorList/locales/it.json";
import moderatorPageRu from "../components/Dashboard/Moderation/ModeratorList/locales/ru.json";
import moderatorPageHi from "../components/Dashboard/Moderation/ModeratorList/locales/hi.json";
import moderatorPageJa from "../components/Dashboard/Moderation/ModeratorList/locales/ja.json";
import moderatorPageKo from "../components/Dashboard/Moderation/ModeratorList/locales/ko.json";
import moderatorPageTr from "../components/Dashboard/Moderation/ModeratorList/locales/tr.json";
import moderatorPagePl from "../components/Dashboard/Moderation/ModeratorList/locales/pl.json";

import profanityPageEn from "../components/Dashboard/Filters/locales/en.json";
import profanityPageDe from "../components/Dashboard/Filters/locales/de.json";
import profanityPageFr from "../components/Dashboard/Filters/locales/fr.json";
import profanityPagePt from "../components/Dashboard/Filters/locales/pt.json";
import profanityPageEs from "../components/Dashboard/Filters/locales/es.json";
import profanityPageIt from "../components/Dashboard/Filters/locales/it.json";
import profanityPageRu from "../components/Dashboard/Filters/locales/ru.json";
import profanityPageHi from "../components/Dashboard/Filters/locales/hi.json";
import profanityPageJa from "../components/Dashboard/Filters/locales/ja.json";
import profanityPageKo from "../components/Dashboard/Filters/locales/ko.json";
import profanityPageTr from "../components/Dashboard/Filters/locales/tr.json";
import profanityPagePl from "../components/Dashboard/Filters/locales/pl.json";

import templatePageEn from "../components/Dashboard/Templates/locales/en.json";
import templatePageDe from "../components/Dashboard/Templates/locales/de.json";
import templatePageFr from "../components/Dashboard/Templates/locales/fr.json";
import templatePagePt from "../components/Dashboard/Templates/locales/pt.json";
import templatePageEs from "../components/Dashboard/Templates/locales/es.json";
import templatePageIt from "../components/Dashboard/Templates/locales/it.json";
import templatePageRu from "../components/Dashboard/Templates/locales/ru.json";
import templatePageHi from "../components/Dashboard/Templates/locales/hi.json";
import templatePageJa from "../components/Dashboard/Templates/locales/ja.json";
import templatePageKo from "../components/Dashboard/Templates/locales/ko.json";
import templatePageTr from "../components/Dashboard/Templates/locales/tr.json";
import templatePagePl from "../components/Dashboard/Templates/locales/pl.json";

import menuEn from "../components/Dashboard/Menus/locales/en.json";
import menuDe from "../components/Dashboard/Menus/locales/de.json";
import menuFr from "../components/Dashboard/Menus/locales/fr.json";
import menuPt from "../components/Dashboard/Menus/locales/pt.json";
import menuEs from "../components/Dashboard/Menus/locales/es.json";
import menuIt from "../components/Dashboard/Menus/locales/it.json";
import menuRu from "../components/Dashboard/Menus/locales/ru.json";
import menuHi from "../components/Dashboard/Menus/locales/hi.json";
import menuJa from "../components/Dashboard/Menus/locales/ja.json";
import menuKo from "../components/Dashboard/Menus/locales/ko.json";
import menuTr from "../components/Dashboard/Menus/locales/tr.json";
import menuPl from "../components/Dashboard/Menus/locales/pl.json";

import helpPageEn from "../components/Dashboard/Help/locales/en.json";
import helpPageDe from "../components/Dashboard/Help/locales/de.json";
import helpPageFr from "../components/Dashboard/Help/locales/fr.json";
import helpPagePt from "../components/Dashboard/Help/locales/pt.json";
import helpPageEs from "../components/Dashboard/Help/locales/es.json";
import helpPageIt from "../components/Dashboard/Help/locales/it.json";
import helpPageRu from "../components/Dashboard/Help/locales/ru.json";
import helpPageHi from "../components/Dashboard/Help/locales/hi.json";
import helpPageJa from "../components/Dashboard/Help/locales/ja.json";
import helpPageKo from "../components/Dashboard/Help/locales/ko.json";
import helpPageTr from "../components/Dashboard/Help/locales/tr.json";
import helpPagePl from "../components/Dashboard/Help/locales/pl.json";

import cookiebardisplayEn from "../components/Dashboard/CookieInfoBar/locales/en.json";
import cookiebardisplayDe from "../components/Dashboard/CookieInfoBar/locales/de.json";
import cookiebardisplayFr from "../components/Dashboard/CookieInfoBar/locales/fr.json";
import cookiebardisplayPt from "../components/Dashboard/CookieInfoBar/locales/pt.json";
import cookiebardisplayEs from "../components/Dashboard/CookieInfoBar/locales/es.json";
import cookiebardisplayIt from "../components/Dashboard/CookieInfoBar/locales/it.json";
import cookiebardisplayRu from "../components/Dashboard/CookieInfoBar/locales/ru.json";
import cookiebardisplayHi from "../components/Dashboard/CookieInfoBar/locales/hi.json";
import cookiebardisplayJa from "../components/Dashboard/CookieInfoBar/locales/ja.json";
import cookiebardisplayKo from "../components/Dashboard/CookieInfoBar/locales/ko.json";
import cookiebardisplayTr from "../components/Dashboard/CookieInfoBar/locales/tr.json";
import cookiebardisplayPl from "../components/Dashboard/CookieInfoBar/locales/pl.json";

import proLoadErrorsEn from "../services/PreloadService/locales/en.json";
import proLoadErrorsDe from "../services/PreloadService/locales/de.json";
import proLoadErrorsFr from "../services/PreloadService/locales/fr.json";
import proLoadErrorsPt from "../services/PreloadService/locales/pt.json";
import proLoadErrorsEs from "../services/PreloadService/locales/es.json";
import proLoadErrorsIt from "../services/PreloadService/locales/it.json";
import proLoadErrorsRu from "../services/PreloadService/locales/ru.json";
import proLoadErrorsHi from "../services/PreloadService/locales/hi.json";
import proLoadErrorsJa from "../services/PreloadService/locales/ja.json";
import proLoadErrorsKo from "../services/PreloadService/locales/ko.json";
import proLoadErrorsTr from "../services/PreloadService/locales/tr.json";
import proLoadErrorsPl from "../services/PreloadService/locales/pl.json";

import eulaEn from "../eula/locales/en.json";
import eulaDe from "../eula/locales/de.json";
import eulaFr from "../eula/locales/fr.json";
import eulaPt from "../eula/locales/pt.json";
import eulaEs from "../eula/locales/es.json";
import eulaIt from "../eula/locales/it.json";
import eulaRu from "../eula/locales/ru.json";
import eulaHi from "../eula/locales/hi.json";
import eulaJa from "../eula/locales/ja.json";
import eulaKo from "../eula/locales/ko.json";
import eulaTr from "../eula/locales/tr.json";
import eulaPl from "../eula/locales/pl.json";

import privacyPolicyEn from "../privacyPolicy/locales/en.json";
import privacyPolicyDe from "../privacyPolicy/locales/de.json";
import privacyPolicyFr from "../privacyPolicy/locales/fr.json";
import privacyPolicyPt from "../privacyPolicy/locales/pt.json";
import privacyPolicyEs from "../privacyPolicy/locales/es.json";
import privacyPolicyIt from "../privacyPolicy/locales/it.json";
import privacyPolicyRu from "../privacyPolicy/locales/ru.json";
import privacyPolicyHi from "../privacyPolicy/locales/hi.json";
import privacyPolicyJa from "../privacyPolicy/locales/ja.json";
import privacyPolicyKo from "../privacyPolicy/locales/ko.json";
import privacyPolicyTr from "../privacyPolicy/locales/tr.json";
import privacyPolicyPl from "../privacyPolicy/locales/pl.json";

import priceSelectorDisplayEn from "../components/common/PriceSelector/locales/en.json";
import priceSelectorDisplayDe from "../components/common/PriceSelector/locales/de.json";
import priceSelectorDisplayFr from "../components/common/PriceSelector/locales/fr.json";
import priceSelectorDisplayPt from "../components/common/PriceSelector/locales/pt.json";
import priceSelectorDisplayEs from "../components/common/PriceSelector/locales/es.json";
import priceSelectorDisplayIt from "../components/common/PriceSelector/locales/it.json";
import priceSelectorDisplayRu from "../components/common/PriceSelector/locales/ru.json";
import priceSelectorDisplayHi from "../components/common/PriceSelector/locales/hi.json";
import priceSelectorDisplayJa from "../components/common/PriceSelector/locales/ja.json";
import priceSelectorDisplayKo from "../components/common/PriceSelector/locales/ko.json";
import priceSelectorDisplayTr from "../components/common/PriceSelector/locales/tr.json";
import priceSelectorDisplayPl from "../components/common/PriceSelector/locales/pl.json";

import notificationDisplayEn from "../components/common/NotificationModal/locales/en.json";
import notificationDisplayDe from "../components/common/NotificationModal/locales/de.json";
import notificationDisplayFr from "../components/common/NotificationModal/locales/fr.json";
import notificationDisplayPt from "../components/common/NotificationModal/locales/pt.json";
import notificationDisplayEs from "../components/common/NotificationModal/locales/es.json";
import notificationDisplayIt from "../components/common/NotificationModal/locales/it.json";
import notificationDisplayRu from "../components/common/NotificationModal/locales/ru.json";
import notificationDisplayHi from "../components/common/NotificationModal/locales/hi.json";
import notificationDisplayJa from "../components/common/NotificationModal/locales/ja.json";
import notificationDisplayKo from "../components/common/NotificationModal/locales/ko.json";
import notificationDisplayTr from "../components/common/NotificationModal/locales/tr.json";
import notificationDisplayPl from "../components/common/NotificationModal/locales/pl.json";

import errorHandlerEn from "../services/ErrorHandler/locales/en.json";
import errorHandlerDe from "../services/ErrorHandler/locales/de.json";
import errorHandlerFr from "../services/ErrorHandler/locales/fr.json";
import errorHandlerPt from "../services/ErrorHandler/locales/pt.json";
import errorHandlerEs from "../services/ErrorHandler/locales/es.json";
import errorHandlerIt from "../services/ErrorHandler/locales/it.json";
import errorHandlerRu from "../services/ErrorHandler/locales/ru.json";
import errorHandlerHi from "../services/ErrorHandler/locales/hi.json";
import errorHandlerJa from "../services/ErrorHandler/locales/ja.json";
import errorHandlerKo from "../services/ErrorHandler/locales/ko.json";
import errorHandlerTr from "../services/ErrorHandler/locales/tr.json";
import errorHandlerPl from "../services/ErrorHandler/locales/pl.json";

i18n.use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
        resources: {
            en: {
                // English
                homePage: homePageEn,
                dashboard: dashboardEn,
                settings: settingsEn,
                testMemeContainer: testMemeContainerEn,
                manualApproval: manualApprovalEn,
                moderatorPage: moderatorPageEn,
                profanityPage: profanityPageEn,
                templatesPage: templatePageEn,
                helpPage: helpPageEn,
                menu: menuEn,
                eula: eulaEn,
                privacyPolicy: privacyPolicyEn,
                cookieBar: cookiebardisplayEn,
                preloadErrors: proLoadErrorsEn,
                priceSelectorDisplay: priceSelectorDisplayEn,
                notifactionDisplay: notificationDisplayEn,
                errorHandler: errorHandlerEn,
            },
            de: {
                // German
                homePage: homePageDe,
                dashboard: dashboardDe,
                settings: settingsDe,
                testMemeContainer: testMemeContainerDe,
                manualApproval: manualApprovalDe,
                moderatorPage: moderatorPageDe,
                profanityPage: profanityPageDe,
                templatesPage: templatePageDe,
                helpPage: helpPageDe,
                menu: menuDe,
                eula: eulaDe,
                privacyPolicy: privacyPolicyDe,
                cookieBar: cookiebardisplayDe,
                preloadErrors: proLoadErrorsDe,
                priceSelectorDisplay: priceSelectorDisplayDe,
                notifactionDisplay: notificationDisplayDe,
                errorHandler: errorHandlerDe,
            },
            fr: {
                // France
                homePage: homePageFr,
                dashboard: dashboardFr,
                settings: settingsFr,
                testMemeContainer: testMemeContainerFr,
                manualApproval: manualApprovalFr,
                moderatorPage: moderatorPageFr,
                profanityPage: profanityPageFr,
                templatesPage: templatePageFr,
                helpPage: helpPageFr,
                menu: menuFr,
                eula: eulaFr,
                privacyPolicy: privacyPolicyFr,
                cookieBar: cookiebardisplayFr,
                preloadErrors: proLoadErrorsFr,
                priceSelectorDisplay: priceSelectorDisplayFr,
                notifactionDisplay: notificationDisplayFr,
                errorHandler: errorHandlerFr,
            },
            pt: {
                // Portuguese
                homePage: homePagePt,
                dashboard: dashboardPt,
                settings: settingsPt,
                testMemeContainer: testMemeContainerPt,
                manualApproval: manualApprovalPt,
                moderatorPage: moderatorPagePt,
                profanityPage: profanityPagePt,
                templatesPage: templatePagePt,
                helpPage: helpPagePt,
                menu: menuPt,
                eula: eulaPt,
                privacyPolicy: privacyPolicyPt,
                cookieBar: cookiebardisplayPt,
                preloadErrors: proLoadErrorsPt,
                priceSelectorDisplay: priceSelectorDisplayPt,
                notifactionDisplay: notificationDisplayPt,
                errorHandler: errorHandlerPt,
            },
            es: {
                // Spanish
                homePage: homePageEs,
                dashboard: dashboardEs,
                settings: settingsEs,
                testMemeContainer: testMemeContainerEs,
                manualApproval: manualApprovalEs,
                moderatorPage: moderatorPageEs,
                profanityPage: profanityPageEs,
                templatesPage: templatePageEs,
                helpPage: helpPageEs,
                menu: menuEs,
                eula: eulaEs,
                privacyPolicy: privacyPolicyEs,
                cookieBar: cookiebardisplayEs,
                preloadErrors: proLoadErrorsEs,
                priceSelectorDisplay: priceSelectorDisplayEs,
                notifactionDisplay: notificationDisplayEs,
                errorHandler: errorHandlerEs,
            },
            it: {
                // Italian
                homePage: homePageIt,
                dashboard: dashboardIt,
                settings: settingsIt,
                testMemeContainer: testMemeContainerIt,
                manualApproval: manualApprovalIt,
                moderatorPage: moderatorPageIt,
                profanityPage: profanityPageIt,
                templatesPage: templatePageIt,
                helpPage: helpPageIt,
                menu: menuIt,
                eula: eulaIt,
                privacyPolicy: privacyPolicyIt,
                cookieBar: cookiebardisplayIt,
                preloadErrors: proLoadErrorsIt,
                priceSelectorDisplay: priceSelectorDisplayIt,
                notifactionDisplay: notificationDisplayIt,
                errorHandler: errorHandlerIt,
            },
            ru: {
                // Russian
                homePage: homePageRu,
                dashboard: dashboardRu,
                settings: settingsRu,
                testMemeContainer: testMemeContainerRu,
                manualApproval: manualApprovalRu,
                moderatorPage: moderatorPageRu,
                profanityPage: profanityPageRu,
                templatesPage: templatePageRu,
                helpPage: helpPageRu,
                menu: menuRu,
                eula: eulaRu,
                privacyPolicy: privacyPolicyRu,
                cookieBar: cookiebardisplayRu,
                preloadErrors: proLoadErrorsRu,
                priceSelectorDisplay: priceSelectorDisplayRu,
                notifactionDisplay: notificationDisplayRu,
                errorHandler: errorHandlerRu,
            },
            hi: {
                // Hindi
                homePage: homePageHi,
                dashboard: dashboardHi,
                settings: settingsHi,
                testMemeContainer: testMemeContainerHi,
                manualApproval: manualApprovalHi,
                moderatorPage: moderatorPageHi,
                profanityPage: profanityPageHi,
                templatesPage: templatePageHi,
                helpPage: helpPageHi,
                menu: menuHi,
                eula: eulaHi,
                privacyPolicy: privacyPolicyHi,
                cookieBar: cookiebardisplayHi,
                preloadErrors: proLoadErrorsHi,
                priceSelectorDisplay: priceSelectorDisplayHi,
                notifactionDisplay: notificationDisplayHi,
                errorHandler: errorHandlerHi,
            },
            ja: {
                // Japanese
                homePage: homePageJa,
                dashboard: dashboardJa,
                settings: settingsJa,
                testMemeContainer: testMemeContainerJa,
                manualApproval: manualApprovalJa,
                moderatorPage: moderatorPageJa,
                profanityPage: profanityPageJa,
                templatesPage: templatePageJa,
                helpPage: helpPageJa,
                menu: menuJa,
                eula: eulaJa,
                privacyPolicy: privacyPolicyJa,
                cookieBar: cookiebardisplayJa,
                preloadErrors: proLoadErrorsJa,
                priceSelectorDisplay: priceSelectorDisplayJa,
                notifactionDisplay: notificationDisplayJa,
                errorHandler: errorHandlerJa,
            },
            ko: {
                // Korean (south)
                homePage: homePageKo,
                dashboard: dashboardKo,
                settings: settingsKo,
                testMemeContainer: testMemeContainerKo,
                manualApproval: manualApprovalKo,
                moderatorPage: moderatorPageKo,
                profanityPage: profanityPageKo,
                templatesPage: templatePageKo,
                helpPage: helpPageKo,
                menu: menuKo,
                eula: eulaKo,
                privacyPolicy: privacyPolicyKo,
                cookieBar: cookiebardisplayKo,
                preloadErrors: proLoadErrorsKo,
                priceSelectorDisplay: priceSelectorDisplayKo,
                notifactionDisplay: notificationDisplayKo,
                errorHandler: errorHandlerKo,
            },
            tr: {
                // turkish
                homePage: homePageTr,
                dashboard: dashboardTr,
                settings: settingsTr,
                testMemeContainer: testMemeContainerTr,
                manualApproval: manualApprovalTr,
                moderatorPage: moderatorPageTr,
                profanityPage: profanityPageTr,
                templatesPage: templatePageTr,
                helpPage: helpPageTr,
                menu: menuTr,
                eula: eulaTr,
                privacyPolicy: privacyPolicyTr,
                cookieBar: cookiebardisplayTr,
                preloadErrors: proLoadErrorsTr,
                priceSelectorDisplay: priceSelectorDisplayTr,
                notifactionDisplay: notificationDisplayTr,
                errorHandler: errorHandlerTr,
            },
            pl: {
                // polish
                homePage: homePagePl,
                dashboard: dashboardPl,
                settings: settingsPl,
                testMemeContainer: testMemeContainerPl,
                manualApproval: manualApprovalPl,
                moderatorPage: moderatorPagePl,
                profanityPage: profanityPagePl,
                templatesPage: templatePagePl,
                helpPage: helpPagePl,
                menu: menuPl,
                eula: eulaPl,
                privacyPolicy: privacyPolicyPl,
                cookieBar: cookiebardisplayPl,
                preloadErrors: proLoadErrorsPl,
                priceSelectorDisplay: priceSelectorDisplayPl,
                notifactionDisplay: notificationDisplayPl,
                errorHandler: errorHandlerPl,
            },
        },
        lng: "en", // Default language
        fallbackLng: "en", // Fallback language if the current language is missing translations
        interpolation: {
            escapeValue: false, // React already does escaping
        },
    });

export default i18n;
